module.exports = __webpack_public_path__ + "img/img17.2192972d.png";